<h2>Icon Status</h2>
<p class="section-description">Componente para mostrar estados con iconos y etiquetas. Útil para indicar el estado de documentos, procesos o elementos.</p>

<!-- Estados disponibles -->
<section class="ui-section">
	<h3>Estados Disponibles</h3>
	<p>El componente soporta 4 estados diferentes, cada uno con su icono y color característico.</p>

	<div class="button-grid">
		<div class="button-column">
			<span class="label">Firmado</span>
			<app-icon-status status="signed"></app-icon-status>
			<app-ui-code-block [code]="generateCode({ status: 'signed' })" />
		</div>

		<div class="button-column">
			<span class="label">Pendiente enviar</span>
			<app-icon-status status="pending-send"></app-icon-status>
			<app-ui-code-block [code]="generateCode({ status: 'pending-send' })" />
		</div>

		<div class="button-column">
			<span class="label">Pendiente firma</span>
			<app-icon-status status="pending-sign"></app-icon-status>
			<app-ui-code-block [code]="generateCode({ status: 'pending-sign' })" />
		</div>

		<div class="button-column">
			<span class="label">Pendiente creación</span>
			<app-icon-status status="pending-creation"></app-icon-status>
			<app-ui-code-block [code]="generateCode({ status: 'pending-creation' })" />
		</div>
	</div>
</section>

<!-- Labels personalizados -->
<section class="ui-section">
	<h3>Labels Personalizados</h3>
	<p>Puedes personalizar el texto mostrado usando el input <code>label</code>.</p>

	<div class="button-grid">
		<div class="button-column">
			<span class="label">Con label personalizado</span>
			<app-icon-status status="signed" label="Documento firmado"></app-icon-status>
			<app-ui-code-block [code]="generateCode({ status: 'signed', label: 'Documento firmado' })" />
		</div>

		<div class="button-column">
			<span class="label">Sin label (usa default)</span>
			<app-icon-status status="pending-sign"></app-icon-status>
			<app-ui-code-block [code]="generateCode({ status: 'pending-sign' })" />
		</div>
	</div>
</section>

<!-- Icon on the right -->
<section class="ui-section">
	<h3>Posicionamiento del Icono</h3>
	<p>Usa el input <code>iconRight</code> para posicionar el icono a la derecha del texto.</p>

	<div class="button-grid">
		<div class="button-column">
			<span class="label">Icono a la izquierda (default)</span>
			<app-icon-status status="signed" label="Firmado"></app-icon-status>
			<app-ui-code-block [code]="generateCode({ status: 'signed', label: 'Firmado' })" />
		</div>

		<div class="button-column">
			<span class="label">Icono a la derecha</span>
			<app-icon-status status="signed" label="Firmado" [iconRight]="true"></app-icon-status>
			<app-ui-code-block [code]="generateCode({ status: 'signed', label: 'Firmado', iconRight: true })" />
		</div>
	</div>
</section>
